import React, { useCallback, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import useEventData from '../hooks/useEventData'
import TicketButton from './TicketButton'
import EventTime from './EventTime'
import TicketModal from './TicketModal'
import { getNextChildEvent } from '../utils'
import EventCountdown from './EventCountdown'

const Title = ({ children }) => <span className="text-white text-lg">{children}</span>

const MobileCta = ({ event, history, user, onReserve }) => {
  const [isDetailsOpen, setIsDetailsOpen] = useState(false)
  const isSingleEvent = useMemo(() => event.series?.length === 1 || !user, [event, user])
  const eventDate = useMemo(() => event.startTime && moment(event.startTime), [event])
  const childEvent = useMemo(() => {
    return isSingleEvent ? event.series[0] : getNextChildEvent(event)
  }, [event, isSingleEvent])

  const eventData = useEventData({ event, childEvent })

  const handleReserve = useCallback(
    event => {
      if (isSingleEvent) {
        return onReserve(event)
      }
      setIsDetailsOpen(true)
    },
    [isSingleEvent, onReserve]
  )

  return (
    <>
      <div className="flex justify-between pb-4">
        {user?.id ? (
          <>
            {eventData.isCompleted ? (
              <Title>No Upcoming Events</Title>
            ) : (
              <EventTime
                startDateString={eventData.startDateString}
                timeString={eventData.timeString}
              />
            )}
          </>
        ) : eventData.isCompleted ? (
          <Title>{`Invited by ${event.host.name}`}</Title>
        ) : (
          <EventCountdown
            startTime={event.startTime}
            hostName={event.host.name}
            eventDate={eventDate}
            onMobile={true}
          />
        )}
        <TicketButton
          event={event}
          eventData={eventData}
          linkId={event.host.linkId}
          hostName={event.host.name}
          history={history}
          onReserve={handleReserve}
          user={user}
          showPrice={isSingleEvent && !eventData.userSignedUpAlready}
          {...(!isSingleEvent ? { onClick: () => setIsDetailsOpen(true) } : {})}
        />
      </div>
      <TicketModal
        show={isDetailsOpen}
        event={event}
        history={history}
        onReserve={onReserve}
        user={user}
        onClose={() => setIsDetailsOpen(false)}
      />
    </>
  )
}

MobileCta.propTypes = {
  onReserve: PropTypes.func,
  history: PropTypes.object,
  user: PropTypes.object,
  event: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    status: PropTypes.string,
    location: PropTypes.string,
    image: PropTypes.string,
  }),
}

export default MobileCta
